import { animate, AnimationTriggerMetadata, style, transition, trigger, query, stagger, animateChild } from '@angular/animations';

const ENTERING_ANIMATION = '250ms cubic-bezier(0.0, 0.0, 0.2, 1)';
const LEAVING_ANIMATION = '375ms cubic-bezier(0.4, 0.0, 1, 1)';

export const AddRemoveListItemsAnimation: AnimationTriggerMetadata[] = [
	trigger('items', [
		transition(':enter', [style({ transform: 'translate3d(-110%, 0, 0)' }), animate(ENTERING_ANIMATION, style({ transform: 'translate3d(0, 0, 0)' }))]),
		transition(':leave', [style({ transform: 'translate3d(0, 0, 0)' }), animate(LEAVING_ANIMATION, style({ transform: 'translate3d(110%, 0, 0)' }))])
	]),
	trigger('list', [transition(':enter', [query('@items', stagger(50, animateChild()), { optional: true })])])
];
